import {useMedia} from 'react-use';

export function useIsTablet(): boolean {
  return useMedia('(max-width: 1280px)');
}
